import { render, staticRenderFns } from "./ReviewNotesList.vue?vue&type=template&id=605d99c2&scoped=true"
import script from "./ReviewNotesList.vue?vue&type=script&lang=js"
export * from "./ReviewNotesList.vue?vue&type=script&lang=js"
import style0 from "./ReviewNotesList.vue?vue&type=style&index=0&id=605d99c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d99c2",
  null
  
)

export default component.exports